import { Injectable } from '@angular/core';
import cities from '../../../../../assets/data/cities.json';
import { ICity } from './city.interface';

@Injectable({
  providedIn: 'root'
})
export class CitiesService {

  normalizedCities: ICity[];
  capCities: ICity[];

  constructor() {
    this.normalizedCities = this.normalizeAllNames();
  }

  getCityInfo(cityName: string): ICity {
    const normalizedName = this.normalize(cityName);
    const filtered: ICity[] = this.normalizedCities.filter(city => {
      return (normalizedName === city.normName) || (normalizedName === city.normEngName);
    });

    return filtered[0];
  }

  getCityById(id: any): ICity {
    if (isNaN(id)) {
      const customCity: ICity = {id, nameEN: id, nameHE: id, subdistrict_id: '0', district_id: '0'};
      return customCity;
    }
    const filtered: ICity[] = this.normalizedCities.filter(city => {
      return (id === city.id);
    });

    return filtered[0];
  }

  private normalizeAllNames(): ICity[] {
    return cities.filter((city: ICity) => {
      const nameHE = this.normalize(city.nameHE);
      const nameEN = this.normalize(city.nameEN);
      city.normName = nameHE;
      city.normEngName = nameEN;
      return city;
    });
  }

  private getCities(): ICity[] {
    return cities;
  }

  private normalize(str: string): string {
    return str.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').toLowerCase();
  }

}

